import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  SaveSearchContainer,
  TOnSubmitSaveSearchParams,
  useSaveSearchEvents,
} from 'shared/common/packages/SaveSearchModal';

import { trackSaveSearchModalClose, trackSaveSearchModalOpen, trackSaveSearchSubscribed } from './tracking';
import { isSuburban, offerTypeFromJsonQuery } from '../../../common/packages/JsonQuery';
import { selectQueryString } from '../../selectors/queryString';
import { selectJsonQuery } from '../../selectors/results';

export const SaveSearchModalContainer: React.FC = () => {
  const jsonQuery = useSelector(selectJsonQuery);
  const isSuburbanMap = isSuburban(offerTypeFromJsonQuery(jsonQuery));
  const deviceType = useDeviceType();
  const queryString = useSelector(selectQueryString);

  const handleSubscribed = React.useCallback(
    (parameters: TOnSubmitSaveSearchParams) => {
      trackSaveSearchSubscribed({
        ...parameters,
        deviceType,
        queryString,
      });
    },
    [deviceType, queryString],
  );

  const handleOpen = React.useCallback(() => {
    trackSaveSearchModalOpen();
  }, []);

  const handleClose = React.useCallback(() => {
    if (isSuburbanMap) {
      trackSaveSearchModalClose();
    }
  }, [isSuburbanMap]);

  useSaveSearchEvents(handleSubscribed, handleOpen, handleClose);

  return <SaveSearchContainer />;
};
